export function isTokenExpirationValid(expires: number) {
  return new Date().getTime() < expires * 1000;
}

export function isTokenExpired(expires: number) {
  return !isTokenExpirationValid(expires);
}
